import { render, staticRenderFns } from "./courselist.vue?vue&type=template&id=438f7836&scoped=true"
import script from "./courselist.vue?vue&type=script&lang=js"
export * from "./courselist.vue?vue&type=script&lang=js"
import style0 from "./courselist.vue?vue&type=style&index=0&id=438f7836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438f7836",
  null
  
)

export default component.exports